import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { FaAngleDown } from 'react-icons/fa';
import PageHeader from '../pages/PageHeader';
const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
    window.scrollTo(0, 0); // This will move the user to the top of the page
  }, []);
  

  const faqs = [
    {
      question: "What services does AppNexts provide?",
      answer: "AppNexts offers a wide range of digital solutions tailored to meet your needs. Our services include business website development, directories website development, app development for both Android and iOS platforms, SEO services, video editing, graphic design, data scraping, and custom software development. Whether you need to establish your online presence, enhance your digital marketing efforts, or develop custom software solutions, AppNexts is here to help you achieve your goals."
    },
    {
      question: "How much do your services cost?",
      answer: "The cost of our services varies depending on the scope of the project and the services required. We provide customized quotes for each project based on the unique business requirements."
    },
    {
      question: "How does the development process work at AppNexts?",
      answer: "Our development process includes a discovery phase, design phase, development phase, testing and QA phase, deployment and launch phase, and post-launch phase. During each phase, we keep our clients informed and involved to ensure that the project meets their business requirements."
    },
    {
      question: "How long does it take to complete a project?",
      answer: "The timeline for each project depends on the scope of the project and the services required. We work closely with our clients to establish a realistic timeline and keep them informed of the project's progress throughout the development process."
    },
    {
      question: "What technology stack does AppNexts use?",
      answer: "We use a variety of technology stacks, including but not limited to, HTML, CSS, JavaScript, Flutter, React, React Native, Angular, Vue, Firebase, Node.js, Python, Ruby on Rails, Laravel, and .NET."
    },
    {
      question: "How do you ensure the security of client data?",
      answer: "We take data security seriously and use the latest security protocols and tools to ensure the security of our clients' data. We also have strict confidentiality policies in place to protect our clients' sensitive information."
    },
    {
      question: "What is your customer support policy?",
      answer: "We provide ongoing support and maintenance for our software development projects to ensure that the software is up-to-date and functioning optimally. We also have a customer support team available to address any questions or concerns our clients may have."
    },
  ];

  return (
    <section>
      <Helmet>
  {/* Meta Title */}
  <title>FAQ | AppNexts - Your Digital Solutions Partner</title>

  {/* Meta Description */}
  <meta
    name="description"
    content="Browse frequently asked questions at AppNexts to learn more about our services including app development, web development, SEO, and digital marketing."
  />

  {/* Meta Keywords */}
  <meta
    name="keywords"
    content="FAQ, frequently asked questions, app development, web development, SEO services, digital marketing, graphic design, video editing, data scraping, AppNexts"
  />

  {/* Canonical URL */}
  <link rel="canonical" href="https://www.appnexts.com/faqs" />

  {/* Open Graph Tags */}
  <meta property="og:title" content="FAQ | AppNexts - Your Digital Solutions Partner" />
  <meta
    property="og:description"
    content="Explore our FAQs to find answers about AppNexts services such as web/app development, SEO, video editing, and more."
  />
  <meta
    property="og:image"
    content="https://www.appnexts.com/seo_image/FAQ_seo.png"
  />
  <meta property="og:url" content="https://www.appnexts.com/faqs" />
  <meta property="og:type" content="website" />

  {/* Twitter Card Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="FAQ | AppNexts - Your Digital Solutions Partner" />
  <meta
    name="twitter:description"
    content="Find answers to the most common questions about AppNexts' services including SEO, web & app development, and more."
  />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/FAQ_seo.png" />

  {/* Structured Data (for search engine enhancement) */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What services does AppNexts provide?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "AppNexts offers web development, mobile app development, SEO services, data scraping, video editing, and graphic design."
          }
        },
        {
          "@type": "Question",
          "name": "How can I contact AppNexts?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can contact us via our contact page at https://www.appnexts.com/contact-us."
          }
        }
      ]
    })}
  </script>
</Helmet>

       <PageHeader title="Frequently Asked Questions" breadcrumb={[{ label: "Home", path: "/" },{ label: "Frequently Asked Questions" }]}/>

      
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 font-semibold my-4">
        <div className="accordion-group space-y-4" > 
          {faqs.map((faq, index) => (
            <div data-aos="fade-up">
            <div
              key={index}
              className={`accordion py-5 px-6 border border-solid border-gray-200 transition-all duration-200 rounded-2xl  
                ${openIndex === index ? 'bg-[#504e9a] text-white' : 'bg-[#f7f8fd] text-gray-900'}`} 
            >
              <button
                className={`accordion-toggle group inline-flex items-center justify-between leading-8 w-full transition duration-200 text-left ${openIndex === index ? 'text-white' : 'text-gray-900'}`} 
                onClick={() => handleToggle(index)}
                aria-controls={`accordion-collapse-${index}`}
              >
                <h5>{faq.question}</h5>
                <FaAngleDown className={`transition duration-200 ${openIndex === index ? 'rotate-180 text-white' : 'text-[#304f7c]'}`}  />
                
              </button>
              <div
                id={`accordion-collapse-${index}`}
                className={`accordion-content w-full px-0 overflow-hidden transition-all duration-200 ${openIndex === index ? 'max-h-screen' : 'max-h-0'}`}
                aria-labelledby={`accordion-heading-${index}`}
              >
                <p className={`text-base leading-6 ${openIndex === index ? 'text-white' : 'text-gray-900'}`}>{faq.answer}</p> 
              </div>
            </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
